<template>
  <div>
<div class="form">
              <br />
              <br />
Merci de votre confiance.<br /><br />
Votre demande de remboursement a bien été enregistrée. Vous allez recevoir prochainement un email de confirmation dans votre boîte de réception.
<br />
A bientôt,<br />
<br />
L'équipe GARDENA France</div>
</div>
</template>
<script>
var consts = require('../config');

export default {
  name: 'home',
}
</script>